import axios from "axios";

export default {
  state: {
    archive: {
      loading: false,
      value: {},
    },
  },
  getters: {},
  mutations: {
    SET_ARCHIVE(state, { loading = false, value = {} }) {
      state.archive = {
        loading,
        value,
      };
    },
  },
  actions: {
    async fetchFiles({ commit, state, rootState }, filters) {
      try {
        commit("SET_ARCHIVE", { loading: true });
        const { data } = await axios.get("api/process", {
          params: filters,
          headers: {
            Authorization: rootState.auth.token,
          },
        });
        commit("SET_ARCHIVE", { value: data });
        return data;
      } catch (error) {
        console.error(error);
      }
    },
  },
  namespaced: true,
};
